import { GetMetersByMpxnMsnQuery } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { MeterSummary } from "./meterSummary"
import { IMeterSummary } from "./meterSummary.types"

export type IMeterSummaryRaw = GetMetersByMpxnMsnQuery["meter"][number]

export const MeterSummaryParser: IParser<IMeterSummary, IMeterSummaryRaw> = {
  toDomain: (data: IMeterSummaryRaw): IMeterSummary => {
    try {
      return new MeterSummary(
        data.identifier,
        String(data.type),
        data.meter_meter_point_rels.map((rel) => rel.meter_point.identifier),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
